import { Simulation, SimulationStatus } from '@helpers/types.ts';
import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { differenceInHours } from 'date-fns';
import { TIME_EXPIRATION_CONTAINERS } from '@helpers/constants.tsx';
import { JoinFull, JoinRight } from '@mui/icons-material';

interface IActionPlanInductionProps {
  plan?: Simulation;
  selected: Array<string>;
  onAcceptPlan: () => void;
  onRejectPlan: () => void;
  loadingInduction: boolean;
  startInduction: () => void;
  onStartJoinRoutes: () => void;
  isEditMode: boolean;
  cancelSelection: () => void;
  startSelection: () => void;
}

export const ActionPlanInduction: FC<IActionPlanInductionProps> = (props) => {
  if (!props.plan) return null;
  if (
    props.plan?.induct_accept == SimulationStatus.pending ||
    !props.plan?.induct_accept
  )
    return (
      <Stack direction="row" spacing={1}>
        <LoadingButton
          size="small"
          color="error"
          variant="contained"
          disableElevation
          onClick={props.onRejectPlan}
          loading={props.loadingInduction}
        >
          Rechazar
        </LoadingButton>
        <LoadingButton
          size="small"
          color="primary"
          variant="contained"
          disableElevation
          onClick={props.onAcceptPlan}
          loading={props.loadingInduction}
        >
          Aprobar
        </LoadingButton>
        <div className="w-8"></div>
        <Button
          size="small"
          color="info"
          disableElevation
          variant="contained"
          startIcon={<JoinFull />}
          onClick={props.onStartJoinRoutes}
          disabled={props.selected.length == 0}
        >
          Unir rutas
        </Button>
        {!props.isEditMode ? (
          <Button
            size="small"
            color="info"
            disableElevation
            variant="contained"
            startIcon={<JoinRight />}
            onClick={props.startSelection}
          >
            Trasladar ordenes
          </Button>
        ) : (
          <Button
            size="small"
            color="warning"
            disableElevation
            variant="contained"
            startIcon={<JoinRight />}
            onClick={props.cancelSelection}
          >
            Cancelar traslado
          </Button>
        )}
      </Stack>
    );

  if (props.plan?.induct_accept == SimulationStatus.rejected)
    return (
      <Typography
        color={'error'}
        variant="overline"
        fontSize={'large'}
        fontWeight={'bold'}
      >
        Plan rechazado
      </Typography>
    );
  const valid =
    differenceInHours(new Date(), new Date(props.plan.updated_at)) <
    TIME_EXPIRATION_CONTAINERS;

  if (!valid)
    return (
      <Typography
        color={'error'}
        variant="overline"
        fontSize={'large'}
        fontWeight={'bold'}
      >
        Plan caducado
      </Typography>
    );

  return (
    <Button
      size="small"
      color="primary"
      disableElevation
      variant="contained"
      disabled={props.selected.length === 0}
      onClick={props.startInduction}
    >
      INDUCCIÓN
    </Button>
  );
};
